import $ from 'jquery';
import { onAvailable } from '@core/plugins/lib/selectors';

export const ELEMENT_SELECTOR = '[data-trigger-event]';
export const PLUGIN_NAME = 'triggerEvent';


$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function(element) {
		System.import(/* webpackChunkName: "plugin--trigger-event" */ './plugin').then(() => {
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/plugins/jquery__trigger-event/index.js